import ChevronRightIcon from '@mui/icons-material/ChevronRightOutlined'
import { Box, MenuList, Popover } from '@mui/material'
import type { PropsWithChildren } from 'react'
import React from 'react'

import { UserChipMenuContext } from './context'
import * as S from './styles'

export interface UserChipProps {
  avatar: string | null | undefined
  initials: string | undefined
  name: string | undefined
  subtext?: string
  isShrunk: boolean
}

export const UserChipMenu: React.FC<PropsWithChildren<UserChipProps>> = ({
  avatar,
  initials,
  name,
  subtext,
  children,
  isShrunk,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const isOpen = !!anchorEl

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <S.UserChip
        onClick={handleClick}
        data-test="userMenu"
        state={isOpen ? 'active' : 'default'}
        isExpanded={!isShrunk}
        {...props}
      >
        {avatar ? (
          <S.Avatar alt="user" src={avatar} />
        ) : (
          <S.AvatarPlaceholder>
            <S.AvatarInitials>{initials}</S.AvatarInitials>
          </S.AvatarPlaceholder>
        )}
        <S.LabelContainer>
          <Box component="div">
            <S.Label variant="body2">{name}</S.Label>
            {subtext && (
              <S.Label variant="body2" color="textSecondary">
                {subtext}
              </S.Label>
            )}
          </Box>
          <ChevronRightIcon />
        </S.LabelContainer>
      </S.UserChip>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
      >
        <MenuList disablePadding>
          <UserChipMenuContext.Provider value={handleClose}>
            {children}
          </UserChipMenuContext.Provider>
        </MenuList>
      </Popover>
    </>
  )
}

UserChipMenu.displayName = 'UserChip'
